var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardMethod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 117.789,
    height: 17,
    viewBox: "0 0 117.789 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48109",
    "data-name": "Group 48109",
    transform: "translate(-1411.211 -652.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "visa-color",
    transform: "translate(1443 652.828)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "card_bg",
    width: 24,
    height: 16,
    rx: 2,
    fill: "#2a2a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "visa-logo",
    d: "M8.51,4.78a3.961,3.961,0,0,1-1.33-.24l.22-1a2.485,2.485,0,0,0,1.127.273l.113,0c.332,0,.71-.24.71-.45s-.179-.315-.62-.57l-.014-.008c-.438-.253-1.037-.6-1.037-1.252,0-.9.823-1.53,2-1.53a3.234,3.234,0,0,1,1.11.2l-.21,1A2.327,2.327,0,0,0,9.616.99c-.072,0-.145,0-.217.01-.345.041-.5.225-.5.39,0,.216.269.36.585.527.483.255,1.085.572,1.085,1.3l.021-.02C10.59,4.16,9.773,4.78,8.51,4.78Zm3.209-.039H10.46L12.26.45a.549.549,0,0,1,.508-.34h1l1,4.629h-1.1l-.17-.69H11.97l-.25.69ZM12.96,1.36,12.33,3.1l1.07-.01ZM6.33,4.73H5.14L6.14.1H7.33l-1,4.63Zm-2.65,0H2.4l-1-3.69A.531.531,0,0,0,1.12.63,5.252,5.252,0,0,0,0,.24V.1H2a.556.556,0,0,1,.55.48l.51,2.67L4.4.1H5.62L3.68,4.73Z",
    transform: "translate(4.6 5.59)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mastercard-color",
    transform: "translate(1474 652.828)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "card_bg-2",
    "data-name": "card_bg",
    width: 24,
    height: 16,
    rx: 2,
    fill: "#f2f0ec"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mastercard",
    transform: "translate(2 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 19.35,
    height: 12.8,
    transform: "translate(0.32 0.6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    "data-name": "Rectangle",
    width: 5.11,
    height: 8.34,
    transform: "translate(7.45 2.83)",
    fill: "#f26122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M6.571,5.3a5.31,5.31,0,0,1,2-4.17,5.3,5.3,0,1,0,0,8.34A5.29,5.29,0,0,1,6.571,5.3Z",
    transform: "translate(1.429 1.7)",
    fill: "#ea1d25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M.5.585V.415H.425v.17Z",
    transform: "translate(17.575 9.705)",
    fill: "#f69e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M.615.605V.4H.565L.5.545.445.4H.385v.21h0V.445l.06.13h0L.5.445v.16Z",
    transform: "translate(17.795 9.686)",
    fill: "#f69e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M8.58,5.307A5.31,5.31,0,0,1,0,9.477a5.31,5.31,0,0,0,2.023-4.17A5.31,5.31,0,0,0,0,1.137a5.3,5.3,0,0,1,8.58,4.17Z",
    transform: "translate(10 1.693)",
    fill: "#f69e1e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "maestro-color",
    transform: "translate(1505 652.828)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "card_bg-3",
    "data-name": "card_bg",
    width: 24,
    height: 16,
    rx: 2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "maestro",
    transform: "translate(2 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    "data-name": "Group",
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    "data-name": "Rectangle",
    width: 19.35,
    height: 12.8,
    transform: "translate(0.32 0.6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    "data-name": "Rectangle",
    width: 5.11,
    height: 8.34,
    transform: "translate(7.45 2.83)",
    fill: "#7272b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    d: "M6.571,5.3a5.31,5.31,0,0,1,2-4.17,5.3,5.3,0,1,0,0,8.34A5.29,5.29,0,0,1,6.571,5.3Z",
    transform: "translate(1.429 1.7)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    d: "M.5.585V.415H.425v.17Z",
    transform: "translate(17.575 9.705)",
    fill: "#00a1de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    "data-name": "Path",
    d: "M.615.605V.4H.565L.5.545.445.4H.385v.21h0V.445l.06.13h0L.5.445v.16Z",
    transform: "translate(17.795 9.686)",
    fill: "#00a1de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    "data-name": "Path",
    d: "M8.58,5.307A5.31,5.31,0,0,1,0,9.477a5.31,5.31,0,0,0,2.023-4.17A5.31,5.31,0,0,0,0,1.137a5.3,5.3,0,0,1,8.58,4.17Z",
    transform: "translate(10 1.693)",
    fill: "#00a1de"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "jcb-color",
    transform: "translate(1411.211 653.828)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "card_bg-4",
    "data-name": "card_bg",
    width: 24,
    height: 16,
    rx: 2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "jcb-logo",
    transform: "translate(4 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-9",
    "data-name": "Path",
    d: "M0,1.03H1.3A.5.5,0,0,0,1.7.52.53.53,0,0,0,1.3,0H0Z",
    transform: "translate(12.05 6.26)",
    fill: "#40a648"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-10",
    "data-name": "Path",
    d: "M2.03,0a2,2,0,0,0-2,2V4.08h3c.64,0,1.11.36,1.11.93a.93.93,0,0,1-.91.91V6A1.035,1.035,0,0,1,4.37,7c0,.6-.55,1-1.27,1H0v4H2.96a2,2,0,0,0,2-2V0Z",
    transform: "translate(11.04)",
    fill: "#40a648"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-11",
    "data-name": "Path",
    d: "M1.56.47A.47.47,0,0,0,1.15,0H0V1H1.15A.48.48,0,0,0,1.56.52Z",
    transform: "translate(12.05 4.68)",
    fill: "#40a648"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-12",
    "data-name": "Path",
    d: "M2,0A2,2,0,0,0,0,2V6.93a3.87,3.87,0,0,0,1.72.45,1,1,0,0,0,1.07-1V4.07H4.52V6.38C4.52,7.29,4,8,2.06,8a8.49,8.49,0,0,1-2-.25V12H2.94a2,2,0,0,0,2-2V0Z",
    fill: "#0d67b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-13",
    "data-name": "Path",
    d: "M2,0A2,2,0,0,0,0,2V4.62A4,4,0,0,1,2.81,4a8.82,8.82,0,0,1,1.57.24v.85a3.74,3.74,0,0,0-1.52-.44c-1.08-.08-1.72.45-1.72,1.37s.64,1.46,1.72,1.37a3.9,3.9,0,0,0,1.52-.44V7.8a8.45,8.45,0,0,1-1.57.24A4,4,0,0,1,0,7.4V12H2.94a2,2,0,0,0,2-2V0Z",
    transform: "translate(5.54)",
    fill: "#be2034"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardMethod);
export default __webpack_public_path__ + "static/media/CreditCardMethod.52172375d5a88a4fdcc36354d550afdc.svg";
export { ForwardRef as ReactComponent };